export class Contact {
  id: string;
  name: string;
  position: string;
  phoneNumber: string;
  createdBy: Date;
  createdDate: Date;
  updatedDate: Date;
  checked: boolean;
  stt: number;
}
